import React from 'react'
import PlanWrapper from '../../Common/PlanWrapper'

const PreventivePlansWrapper = () => (
  <PlanWrapper planType='preventive' planLabel='Preventive Care Plans' isMonitoring={false} />
)

export default PreventivePlansWrapper
